import React, { useRef } from "react";
import db, { auth } from "../firebase";
import "./SingUpScreen.css";
function SingUpScreen() {

  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const SingIn = (e) => {
      e.preventDefault();
      auth
        .signInWithEmailAndPassword(
          emailRef.current.value,
          passwordRef.current.value
        )
        .then((authUser) => {
        })
        .catch((err) => {
          alert(`you have an error : ${err.message}`);
        });  
    
  };

  const register = async (e) => {
    e.preventDefault();
    await auth
      .createUserWithEmailAndPassword(
        emailRef.current.value,
        passwordRef.current.value
      )
      .then((authUser) => {
        db.collection('users')
          .doc(authUser.user.uid)
          .set({
            userName: authUser.user.email,
            DimondPlan: "none",
            GoldPlan: "none",
            PremiumPlan: "none",
            timeStamp: Date(),
          })
          .then(() => {
            alert('account has been created');
          })
          .catch((error) => {
            alert(`Fail to buy plan for, error: ${error.massage}`);
          });
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  return (
    <div className="singupscreen">
      <form>
        <h2>Sing In</h2>
        <input ref={emailRef} placeholder="Email" required type="email" />
        <input
          ref={passwordRef}
          placeholder="Password"
          required
          type="password"
        />
        <button onClick={SingIn} type="submit">
          Sing In
        </button>
        <h4>
          New To Netfilx ?
          <span onClick={register} className="createnewaccount">
            Create Now.
          </span>
        </h4>
      </form>
    </div>
  );
}

export default SingUpScreen;
